/**
 * Picks up what the customer chose on rumio.world before they got here.
 *
 * The marketing site has a version per site type (/lodging, /stores, …) and
 * its plan buttons link to /signup?type=<siteType>&plan=<slug>. The host
 * forwards that query into the iframe URL, so the app boots at
 * `/?plan=growth&type=lodging` — and the root route immediately redirects to
 * /welcome, dropping it. This reads the two params into the wizard store
 * first, so the plan page opens on the tier they clicked and the
 * questionnaire opens on the site type they were reading about, instead of
 * Growth and Ecommerce by default.
 *
 * An explicit link always wins over what the store already holds: it is the
 * customer's most recent choice. Unknown values are ignored, never stored.
 */
import { useWizardStore, type PlanSlug, type SiteTypeChoice } from "@/state/wizard-store";

const PLAN_SLUGS: readonly PlanSlug[] = ["starter", "growth", "pro"];
const SITE_TYPES: readonly SiteTypeChoice[] = ["ecommerce", "saas", "museum", "lodging", "social_casino"];

export function applyMarketingIntent(search: string): void {
  const params = new URLSearchParams(search);
  const plan = params.get("plan");
  const type = params.get("type");
  const store = useWizardStore.getState();
  if (plan && (PLAN_SLUGS as readonly string[]).includes(plan)) {
    store.setPlan(plan as PlanSlug);
  }
  if (type && (SITE_TYPES as readonly string[]).includes(type)) {
    store.setQuestionnaire({ siteType: type as SiteTypeChoice });
  }
}
